import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppNavigation } from 'src/routes';
import { useAuth } from '../contexts/AuthContext';
import { useAuth0 } from '@auth0/auth0-react';
import SuspenseLoader from './SuspenseLoader';

interface ProtectedRoutesProps {
  requiredPermissions?: string[];
  children?: React.ReactNode;
}

export const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({ requiredPermissions, children }) => {
  const location = useLocation();
  const { permissions, isAuthenticated } = useAuth();
  const { isLoading, isAuthenticated: auth0IsAuthenticated } = useAuth0();
  const { routesMap } = useAppNavigation();

  const searchParams = new URLSearchParams(window.location.search);
  const isAuth0Callback = searchParams.has('code') && searchParams.has('state');
  const auth0HasError = searchParams.has('error');

  if (isLoading || isAuth0Callback || auth0HasError) {
    return <SuspenseLoader />;
  }

  if (isAuthenticated) {
    if (requiredPermissions) {
      if (!requiredPermissions.some((permission) => permissions?.includes(permission))) {
        return <Navigate to={routesMap.noPermission} replace state={{ from: location }} />;
      }
    }

    return children ? <>{children}</> : <Outlet />;
  }

  if (!isAuthenticated && !auth0IsAuthenticated) {
    return <Navigate to={routesMap.login} replace state={{ from: location }} />;
  }
};
